module.exports = "automatic-assignment"